<template>
  <div class="searchBox">
    <el-form :inline="true" :model="formClass" label-width="90px" class="searchForm">
      <el-form-item label="班级名称:">
        <el-input v-model="formClass.name" placeholder="输入班级名称"></el-input>
      </el-form-item>
      <el-form-item label="开课时间:" label-width="110px">
        <el-date-picker
          v-model="formClass.startTime"
          type="daterange"
          placeholder="开课时间"
          format="yyyy-MM-dd"
          placement="bottom-end"
          style="width:250px;font-size:10px"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="search" @click="onQuery">搜索</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "queryClassBar",
  components: {},
  data() {
    return {
      formClass: {
        name: "",
        level: "",
        startTime: [],
      },
    };
  },
  props: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {
    onQuery() {
      this.$emit("queryResult", this.formClass);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../fyd-style";
@import "../commonEdu";

</style>


// WEBPACK FOOTER //
// queryClassBar.vue?1cbc9bd1